/* eslint-disable */

import React from "react";

import { fetchGraphQL } from "../../../services/api-raindrop.js";
import JSONBlob from "../../../ui-components/json-blob/json-blob.tsx";
import RaindropCard, {
  RaindropCardStyle,
} from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import { Size } from "../../../logic/enums.ts";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import RaindropMotionFadeUp from "../../../ui-components/raindrop-motion-fade-up/raindrop-motion-fade-up.tsx";
import RaindropHeading from "../../../ui-components/raindrop-heading/raindrop-heading.tsx";

const HighlightBadge = ({ text }) => {
  return (
    <div className=" w-fit font-black bg-color-raindrop-primary border px-4 py-2 rounded-xl  text-white text-sm text-opacity-80">
      {text}
    </div>
  );
};

const BenefitsSection = () => {
  const benefits = [
    {
      icon: "fa-solid fa-seedling",
      text: "Support more charities",
      subtitle: "Split your contribution between even more charities",
    },
    {
      icon: "fa-solid fa-paint-brush",
      text: "Set a custom colour theme",
      subtitle: "Pink a bit much?  Try a blue or a purple theme",
    },
    {
      icon: "fa-solid fa-book",
      text: "More quizzes",
      subtitle: "Want to do a quiz more than once a day?",
    },
    {
      icon: "fa-solid fa-heart",
      text: "Support our team",
      subtitle: "We just want to do some good, but we need to eat too",
    },
  ];

  return (
    <RaindropMotionFadeUp className="flex w-full ">
      <div className="flex flex-col gap-4 w-full">
        <h1 className="text-2xl font-black text-color-text-primary dark:text-color-dark-text-primary">
          Benefits
        </h1>
        <div className="flex flex-col gap-4">
          {benefits.map((benefit, index) => (
            <RaindropMotionFadeUp key={index} delay={0.2 + index * 0.1}>
              <RaindropCard>
                <div className="flex flex-row gap-6 items-center w-full">
                  <i
                    className={`fa ${benefit.icon} text-color-dark-raindrop-secondary dark:text-color-dark-text-primary text-3xl`}
                  />
                  <div className="flex flex-col text-left w-full">
                    <p className="font-bold text-color-text-primary dark:text-color-dark-text-primary text-lg">
                      {benefit.text}
                    </p>
                    <p className="text-color-text-secondary dark:text-color-dark-text-secondary font-semibold">
                      {benefit.subtitle}
                    </p>
                  </div>
                </div>
              </RaindropCard>
            </RaindropMotionFadeUp>
          ))}
        </div>
      </div>
    </RaindropMotionFadeUp>
  );
};

const InfoPanel = () => {
  return (
    <RaindropMotionFadeUp>
      <RaindropCard>
        <RaindropHeading title="Is it really free?" />
        <div className="flex flex-col gap-1 w-full text-left font-bold dark:text-color-dark-text-secondary text-color-text-secondary">
          <p>
            We care about donations, so you have to be donating to be on
            Raindrop Plus.
          </p>
          <p>
            From there, you agree to give 10% of your donation to support our
            work. So the amount that leaves your account is the same, but we get
            a little bit of it.
          </p>
        </div>
      </RaindropCard>
    </RaindropMotionFadeUp>
  );
};

const RaindropPlus = ({ userCurrent, setUserCurrent = (x) => {} }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const isRaindropPlus = userCurrent?.account?.isRaindropPlus;

  const setIsRaindropPlus = (isPlus) => {
    setIsLoading(true);
    fetchGraphQL(`
      mutation {
        updateAccountPlan(
          isSupportingRaindrop: ${isPlus}
        ) {
          id
        }
      }
    `).then((res) => {
      setIsLoading(false);
      if (res?.data?.updateAccountPlan?.id) {
        console.log("Updated account plan");
        setUserCurrent({
          ...userCurrent,
          account: {
            ...userCurrent.account,
            isRaindropPlus: isPlus,
          },
        });
      } else {
        console.error("RD-334 - Failed to update account plan");
      }
    });
  };
  return (
    <div
      className={
        "flex flex-col gap-4 h-full relative px-4 py-12 overflow-y-auto no-scrollbar"
      }
    >
      <RaindropMotionFadeUp>
        <RaindropCard>
          <div className="flex flex-col gap-4 items-center">
            <div className="-translate-y-8">
              <HighlightBadge text={"Upgrade for free"} />
            </div>

            <div className="flex  flex-col md:flex-row gap-4 items-center text-left w-full">
              <i className="fa-solid fa-gem text-color-raindrop-primary text-5xl" />
              <h1 className="text-4xl font-black text-color-text-primary dark:text-color-dark-text-primary">
                Raindrop Plus
              </h1>
            </div>
            <p className="w-full text-left font-bold dark:text-color-dark-text-secondary">
              Upgrade to Raindrop Plus with sharing the minimum donation to
              Raindrop.
            </p>

            <div className="flex flex-col h-12 items-center justify-center w-full gap-2">
              {!isRaindropPlus && (
                <RaindropButton
                  isFluid={true}
                  size={Size.Large}
                  style={ButtonStyle.Primary}
                  title={"Upgrade now"}
                  onClick={() => {
                    setIsRaindropPlus(true);
                  }}
                  isLoading={isLoading}
                />
              )}

              {isRaindropPlus && (
                <RaindropButton
                  title="Cancel Raindrop Plus"
                  onClick={() => {
                    setIsRaindropPlus(false);
                  }}
                />
              )}
            </div>
          </div>
        </RaindropCard>
      </RaindropMotionFadeUp>

      <InfoPanel />

      <BenefitsSection />
    </div>
  );
};

export default RaindropPlus;
